import type {InjectionKey} from 'vue';

/** Provided by App.vue: logs the user out. Call it without arguments, a truthy one reports a failed sign-in. */
export const logoutKey = Symbol() as InjectionKey<() => void>;
